/**
 * Billing localization catalog
 * Defines currency, pricing, and Stripe metadata per supported region
 */

const DEFAULT_PRICE_QUALIFIER = 'per user / month after the full-access trial';

const RAW_BILLING_LOCALES = {
  'en-GB': {
    locale: 'en-GB',
    regionLabel: 'United Kingdom',
    planName: 'Premium',
    currencyCode: 'GBP',
    currencySymbol: '£',
    monthlyPrice: 2.99,
    stripePriceId: 'price_gb_premium',
  },
  'en-US': {
    locale: 'en-US',
    regionLabel: 'United States',
    planName: 'Premium',
    currencyCode: 'USD',
    currencySymbol: '$',
    monthlyPrice: 2.49,
    stripePriceId: 'price_us_premium',
  },
  'en-EU': {
    locale: 'en-EU',
    regionLabel: 'Eurozone',
    planName: 'Premium',
    currencyCode: 'EUR',
    currencySymbol: '€',
    monthlyPrice: 2.29,
    stripePriceId: 'price_eu_premium',
  },
  'en-NG': {
    locale: 'en-NG',
    regionLabel: 'Nigeria',
    planName: 'Premium',
    currencyCode: 'NGN',
    currencySymbol: '₦',
    monthlyPrice: 1900,
    stripePriceId: 'price_ng_premium',
  },
  'en-ZA': {
    locale: 'en-ZA',
    regionLabel: 'South Africa',
    planName: 'Premium',
    currencyCode: 'ZAR',
    currencySymbol: 'R',
    monthlyPrice: 39,
    stripePriceId: 'price_za_premium',
  },
};

const DEFAULT_BILLING_LOCALE = 'en-GB';

const formatPriceDisplay = (symbol, amount) => `${symbol}${Number(amount).toFixed(2)}`;

const enrichLocale = (config) => {
  const priceDisplay = formatPriceDisplay(config.currencySymbol, config.monthlyPrice);
  return {
    priceQualifier: DEFAULT_PRICE_QUALIFIER,
    ...config,
    priceDisplay,
    pricePerUserPerMonth: `${priceDisplay}/month`,
  };
};

export const getBillingLocaleConfig = (locale = DEFAULT_BILLING_LOCALE) => {
  const raw = RAW_BILLING_LOCALES[locale] || RAW_BILLING_LOCALES[DEFAULT_BILLING_LOCALE];
  return enrichLocale(raw);
};

export const listBillingLocales = () =>
  Object.keys(RAW_BILLING_LOCALES).map((key) => enrichLocale(RAW_BILLING_LOCALES[key]));

export const BILLING_LOCALE_CODES = Object.keys(RAW_BILLING_LOCALES);
export { DEFAULT_BILLING_LOCALE };
